<template>
	<svg
		class="ham hamRotate ham7"
		viewBox="0 0 100 100"
		width="80"
		@click="menuBurgerClick"
		:class="classActive"
	>
		<path
			class="line top"
			d="m 70,33 h -40 c 0,0 -6,1.368796 -6,8.5 0,7.131204 6,8.5013 6,8.5013 l 20,-0.0013"
		/>
		<path class="line middle" d="m 70,50 h -40" />
		<path
			class="line bottom"
			d="m 69.575405,67.073826 h -40 c -5.592752,0 -6.873604,-9.348582 1.371031,-9.348582 8.244634,0 19.053564,21.797129 19.053564,12.274756 l 0,-40"
		/>
	</svg>
</template>

<script>
import { EventBus } from '@core/event-bus';
/**
 * Composant permettant d'afficher un svg animé ouverture/fermeture de menu
 */
export default {
	name: 'MenuBurger',
	data() {
		return {
			active: false,
			classActive: '',
		};
	},
	methods: {
		menuBurgerClick() {
			this.active = !this.active;
			this.classActive = this.active ? 'active' : '';
			EventBus.$emit('menu-burger_hamRotate_clicked', this.active);
		},
	},
};
</script>


<style lang="scss" scoped>
@import '~@scss/_vars.scss';
</style>

<style lang="scss">
// https://codepen.io/ainalem/pen/LJYRxz
.ham7 {
	cursor: pointer;

	.top {
		stroke-dasharray: 40 82;
	}

	.middle {
		stroke-dasharray: 40 111;
	}

	.bottom {
		stroke-dasharray: 40 161;
	}

	&.active {
		&.hamRotate {
			transform: rotate(45deg);
		}

		&.hamRotate180 {
			transform: rotate(180deg);
		}

		.top {
			stroke-dasharray: 17 82;
			stroke-dashoffset: -62px;
		}

		.middle {
			stroke-dashoffset: 23px;
		}

		.bottom {
			stroke-dashoffset: -83px;
		}
	}

	.line {
		fill: none;
		transition: stroke-dasharray 400ms, stroke-dashoffset 400ms;
		stroke: #e5512b;
		stroke-width: 5.5;
		stroke-linecap: round;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/global/MenuBurger.vue